import { render } from "./sample.vue?vue&type=template&id=61348822"
import script from "./sample.vue?vue&type=script&lang=js"
export * from "./sample.vue?vue&type=script&lang=js"

import exportComponent from "F:\\fmvic\\Escritorio\\ProyectosDef\\GAB360\\Apps\\Certivin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__